export default "__VITE_ASSET__d01c697b__"